module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-height animated",
    class: {
      'zoomOutUp': _vm.isLock
    }
  }, [_c('div', {
    staticClass: "index"
  }, [_c('sidebar', {
    staticClass: "left"
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('top', {
    staticClass: "top"
  }), _vm._v(" "), _c('tags')], 1), _vm._v(" "), _c('el-scrollbar', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-card', {
    attrs: {
      "body-style": _vm.siteContentViewHeight
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1), _vm._v(" "), (_vm.faqFlag) ? _c('div', {
    staticClass: "floating-module"
  }, [_c('button', {
    staticClass: "floating-button",
    attrs: {
      "id": "online-service"
    },
    on: {
      "click": _vm.openFAQ
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/kf.png",
      "alt": "在线客服"
    }
  })])]) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7d07a5c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/page/index/index.vue
// module id = JXq6
// module chunks = 5